import { IAppealSchema } from "~/entity/Appeals/model/schema";
import { ISelectOption } from "~/shared/ui/Fields/types";
import { IAppealSendForm } from "~/widgets/Modals/AddAppeal/model/schema";

const defaultValues = {
  contactPersonId: { label: "Выберете контактное лицо", value: null },
  comment: "",
  fileIds: [],
};

interface IGetDefaultValuesProps {
  scope: "resolution" | "appeal" | "editor";
  appealInstance: IAppealSchema | null;
  contactsSelectOptions: ISelectOption[];
}

export const getDefaultValues = ({
  scope,
  appealInstance,
  contactsSelectOptions,
}: IGetDefaultValuesProps): IAppealSendForm => {
  if (!appealInstance) {
    return defaultValues;
  }

  switch (scope) {
    case "resolution":
      return defaultValues;

    case "editor":
      return {
        contactPersonId:
          contactsSelectOptions.find(
            (option) =>
              String(option.value) === String(appealInstance.contactPersonId)
          ) ?? defaultValues.contactPersonId,
        comment: appealInstance.resolutionComment,
        fileIds: (appealInstance.files ?? [])
          .filter((file) => file.scope === "resolution")
          .map((file) => String(file.fileId)),
        status: appealInstance.malusStatusFrontend
          ? { label: "Да", value: "true" }
          : { label: "Нет", value: "false" },
      };

    case "appeal":
    default:
      return {
        contactPersonId:
          contactsSelectOptions.find(
            (option) =>
              String(option.value) === String(appealInstance.contactPersonId)
          ) ?? defaultValues.contactPersonId,
        comment: appealInstance.comment,
        fileIds: (appealInstance.files ?? [])
          .filter((file) => file.scope === "appeal")
          .map((file) => String(file.fileId)),
      };
  }
};
